import React from 'react';

type PendingPacingMetricProps = {
  title: string;
  detail: string;
};

export function PendingPacingMetric({ title, detail }: PendingPacingMetricProps) {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-sm font-medium text-gray-800">{title} pacing</span>
      <div className="flex items-baseline gap-3">
        <span className="text-lg font-semibold text-[#181d1f]">-.-%</span>
        <span className="text-xs text-gray-800">{detail}</span>
      </div>
    </div>
  );
}

type ActivePacingMetricProps = {
  title: string;
  pacing: string;
  detail: string;
};

export function ActivePacingMetric({ title, pacing, detail }: ActivePacingMetricProps) {
  return (
    <div className="flex flex-col gap-2 grow">
      <span className="text-sm font-medium text-gray-800">{title} pacing</span>
      <div className="flex items-baseline gap-3">
        <span className="text-lg font-semibold text-[#181d1f]">{pacing}</span>
        <span className="text-xs text-gray-800">{detail}</span>
      </div>
    </div>
  );
}

type ExpiredPacingMetricProps = {
  title: string;
  pacing: string;
  detail: string;
};

export function ExpiredPacingMetric({ title, pacing, detail }: ExpiredPacingMetricProps) {
  return (
    <div className="flex flex-col gap-2 grow">
      <span className="text-sm font-medium text-gray-800">{title}</span>
      <span className="text-lg font-semibold text-[#181d1f]">{pacing}</span>
      <span className="text-xs text-gray-800">{detail}</span>
    </div>
  );
}
